import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
//import { ToastController } from 'ionic-angular';
import Swal from 'sweetalert2';
import { NavController,Tabs,Loading,LoadingController } from 'ionic-angular';
import { AuthService } from '../../providers/auth';
import { ListPage } from '../../pages/list/list';
import { RidePage } from '../../pages/ride/ride';
import { DetailPage } from '../../pages/detail/detail';
//import { AppUpdate } from '@ionic-native/app-update';
@Component({
  selector: 'page-home',
  templateUrl: 'home.html'
})
export class HomePage implements OnInit{
  loading: Loading;
  tab1Root: any = ListPage;
  tab2Root: any = ListPage;
  pet:any;
    
  selectedItem: any;
  obj:any;
  obj2:any;
  obj3:any;
  items;
  user_namenav:any;
  items2;
  items3;
 // constructor(private appUpdate: AppUpdate) {
 //      const updateUrl = 'https://api.fahrdienstpro.de/api/_app_driver_upd.xml';
 //      this.appUpdate.checkAppUpdate(updateUrl).then(() => { console.log('Update available') });
 //   }
  constructor(public loadingCtrl: LoadingController, public navCtrl: NavController,public authService:AuthService, private http: HttpClient) {
    this.pet = 'All';
  }
  
  
  ngOnInit() {
    // Überprüfe alle 20 Sekunden nach neuen Nachrichten
    setInterval(() => {
      this.fetchNewMessages();
    }, 30000); // 30 Sekunden
  }
  
  // Funktion, um neue Nachrichten vom Server abzurufen
  fetchNewMessages() {
    const companyId = localStorage.getItem('company_id');
    const driverId = localStorage.getItem('driver_id');
    if (companyId != null && companyId !== "") {
      const params = new HttpParams().set('company_id', companyId).set('driver_id', driverId);;
      this.http.get('https://api.fahrdienstpro.de/api/get_new_messages.php', { params })
        .subscribe((messages: any) => {
          if (messages.length > 0) {
            // Zeige Push-Benachrichtigungen an
            messages.forEach(message => {
              console.log(message);
              //this.showPushNotification(message);
              this.showAlert(message); 
            });
          }
        }, error => {
          console.error('Fehler beim Abrufen der Nachrichten:', error);
        });
    }  
  }
  showAlert(message: any) {
    const audio = new Audio('https://api.fahrdienstpro.de/button-4.wav');
    audio.play();  // Spiele den Ton ab
    Swal.fire({
      title: '',
      html: `<div class="custom-swal-content">
      <p  style="font-size: 20px;">${message.content}</p>
      <p style="color: red;font-size:12px;">Bitte mit OK bestätigen</p></div>    `,  // HTML im Text verwenden
      icon: 'info', // Das Symbol (z. B. info, success, error)
      confirmButtonText: 'OK',
      customClass: {
        confirmButton: 'my-confirm-button'  // Füge eine benutzerdefinierte Klasse für den OK-Button hinzu
      }
    }).then(() => {
      this.markMessageAsShown(message.id);
    });
  }
  
  
  // Funktion, um die Nachricht als angezeigt zu markieren
  markMessageAsShown(messageId: any) {
    const companyId = localStorage.getItem('company_id');
    const params = new HttpParams().set('company_id', companyId).set('msg_id', messageId);

    this.http.get('https://api.fahrdienstpro.de/api/mark_message_shown.php', { params })
      .subscribe(data => {
        console.log('Nachricht als angezeigt markiert:', data);
      }, error => {
        console.error('Fehler beim Markieren der Nachricht:', error);
      });
  }
  login={"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"Filter":'Today'};

  login_Tomorrow={"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"Filter":'Tomorrow'};

  login_week={"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"Filter":'Weekly'};
  
  ionViewDidLoad() { this.All(); }

accept(orderid,itemdata){
  this.loading = this.loadingCtrl.create({
    content: '',
    });
  let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"status":0}
  let data_parameters=acceptride;
  let method='driver_order_accept_and_cancel.php';
  
  this.authService.postData(data_parameters,method).then((result) => {
    this.loading.present();
    this.obj = result;
    console.log(this.obj);
    
   if(this.obj.status=='true'){
    this.loading.dismiss();
   this.navCtrl.push(HomePage);
  // this.navCtrl.push(RidePage,{ data:itemdata})

    //this.All();
    }
   
   else{
    this.loading.dismiss();
  //  loading.dismiss();
    //alert(this.obj.message);
    }
    
    }, (err) => {
      // Error log
  });
}
reject(orderid){
  this.loading = this.loadingCtrl.create({
    content: '',
    });
  let acceptride={'order_id':orderid,"company_id":localStorage.getItem('company_id'),"driver_id":localStorage.getItem('driver_id'),"status":10}
  let data_parameters=acceptride;
  let method='driver_order_accept_and_cancel.php';
  this.loading.present();
  this.authService.postData(data_parameters,method).then((result) => {
 
    this.obj = result;
    console.log(this.obj);
    
   if(this.obj.status=='true'){
    this.loading.dismiss();
    this.navCtrl.push(HomePage);
    this.All();
    }

   else{
    this.loading.dismiss();
   // this.loading.dismissAll();
    //alert(this.obj.message);
    }
    
    }, (err) => {
      // Error log
  });
}
getprofile(itemdata,dataget){

//this.navCtrl.push(RidePage)
this.navCtrl.push(DetailPage,{ data:itemdata,dataget:dataget})


}
datamap(itemdata){
 this.navCtrl.push(RidePage,{ data:itemdata}) 
 //this.navCtrl.push(ListPage,{ data:itemdata}) 
}

All(){
  this.loading = this.loadingCtrl.create({
    content: '',
    });
  let data_parameters= this.login;
  //let fahrer = localStorage.getItem('driver_id');
  this.user_namenav=localStorage.getItem('name');
  let method='driver_order_details.php';
  //console.log(this.login);
 
  this.authService.postData(data_parameters,method).then((result) => {
    this.loading.present();
    this.obj = result;
    //console.log(this.obj);
    
   if(this.obj.status=='true'){
    this.loading.dismiss();
     this.items=this.obj.response;
     //localStorage.setItem("leerauftrag",this.obj.leerauftrag);
   
 //  localStorage.setItem("name",this.obj.name);
 //  localStorage.setItem("customers_id",this.obj.customers_id);
 //  localStorage.setItem("company_id",this.obj.company_id);
   
   //this.navCtrl.setRoot(HomePage);
    }
   
   else{
    this.loading.dismiss();
    //alert(this.obj.message);
    }
    
    }, (err) => {
      // Error log
  });

}
tomorrow(){
  this.loading = this.loadingCtrl.create({
    content: '',
    });
  let data_parameters_tomorrow= this.login_Tomorrow;
  let method='driver_order_details.php';

  this.authService.postData(data_parameters_tomorrow,method).then((result2) => {
    this.loading.present();
    this.obj2 = result2;
    console.log(this.obj2);
    
   if(this.obj2.status=='true'){
    this.loading.dismiss();
     this.items2=this.obj2.response;

   //this.loading.dismissAll();
   
  //  localStorage.setItem("name",this.obj.name);
  //  localStorage.setItem("customers_id",this.obj.customers_id);
  //  localStorage.setItem("company_id",this.obj.company_id);
  
  
   //this.navCtrl.setRoot(HomePage);
    }
   
   else{
    this.loading.dismiss();
   // this.loading.dismissAll();
    //alert(this.obj2.message);
    }
    
    }, (err) => {
      // Error log
  });

}

week(){
  this.loading = this.loadingCtrl.create({
    content: '',
    });
  let data_parameters_week= this.login_week;
  let method='driver_order_details.php';
  this.authService.postData(data_parameters_week,method).then((result3) => {
    this.loading.present();
    this.obj3 = result3;
    console.log(this.obj3);
    
   if(this.obj3.status=='true'){
     this.items3=this.obj3.response;
     this.loading.dismiss();
   
  //  localStorage.setItem("name",this.obj.name);
  //  localStorage.setItem("customers_id",this.obj.customers_id);
  //  localStorage.setItem("company_id",this.obj.company_id);
  
  
   //this.navCtrl.setRoot(HomePage);
    }
   
   else{
    this.loading.dismiss();
   // alert(this.obj3.message);
    }
    
    }, (err) => {
      // Error log
  });
 }

}



// WEBPACK FOOTER //
// ./src/pages/home/home.ts